import React from 'react';
import {
  CloudServerOutlined,
  ImportOutlined,
  MergeCellsOutlined,
} from '@ant-design/icons';

import Auth0RolesContainer from '@totem/components/administration/auth0/roles/Auth0RolesContainer';
import {
  Auth0RolesExtra,
  Auth0RolesLayout,
} from '@totem/components/administration/auth0/roles/Auth0RolesLayout';
import { SettingType } from '@totem/components/settings/constants';
import ZoneMappingPanel from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingPanel';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { buildingsDisplayName } from '@totem/components/ui_components/constants';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';

export const getMenuAdminMappings = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: SettingType.ZONE_MAPPING,
      title: 'Mappings',
      label: 'Nozomi Zone Mapping',
      description: `Tool Mappings (Tenants -> ${buildingsDisplayName})`,
      route: '/dashboard/admin/mappings',
      content: <ZoneMappingPanel />,
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'auth0roles',
      title: 'Remote Access Roles',
      label: 'Remote Access Roles',
      description: `Remote Access Role Mappings`,
      route: '/dashboard/admin/auth0roles',
      content: (
        <Auth0RolesContainer>
          <IBCard isCovered title="Auth0 Roles" extra={<Auth0RolesExtra />}>
            <Auth0RolesLayout />
          </IBCard>
        </Auth0RolesContainer>
      ),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'deviceSyncMerges',
      title: 'Device Sync Merges',
      label: 'Device Sync Merges',
      description: 'Devices a sync found more than once - merge or dismiss',
      route: '/dashboard/admin/deviceSyncMerges',
      icon: <MergeCellsOutlined />,
      hasPermissions: () => {
        return permissions.internalSystemAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'amazonWebServices',
      title: 'Amazon Web Services',
      label: 'AWS',
      description: 'AWS EC2 Instance & Cost Administration',
      route: '/dashboard/admin/amazonWebServices',
      icon: <CloudServerOutlined />,
      hasPermissions: () => {
        return permissions.internal.hasPermissions(userProfile);
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
